"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHashes = exports.getCircuitBreakerSize = exports.getCircuitBreaker = void 0;
var circuitBreaker_1 = require("./circuitBreaker");
var store = new Map();
function getCircuitBreaker(hash, settings) {
    if (store.has(hash)) {
        var circuitBreaker_2 = store.get(hash);
        circuitBreaker_2.setConfig(settings);
        return circuitBreaker_2;
    }
    var circuitBreaker = new circuitBreaker_1.CircuitBreaker(settings);
    store.set(hash, circuitBreaker);
    return circuitBreaker;
}
exports.getCircuitBreaker = getCircuitBreaker;
function getCircuitBreakerSize() {
    return store.size;
}
exports.getCircuitBreakerSize = getCircuitBreakerSize;
function getHashes() {
    return Array.from(store.keys());
}
exports.getHashes = getHashes;
//# sourceMappingURL=circuitBreakersStore.js.map